<div class="body">
  <div class="container ">
    <div class="row title-box mt-3">
      <div class="col-12 col-sm-12">
        <h3 class="txtbienvenida">Administración de <span class="txtbienvenida-2">cargos y/o garantías </span></h3>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-12 col-sm-12 mt-3">
        <p class="title-box">*Desde aqui puedes administrar los cargos y/o garantías de crédito que quieres atender en la plataforma</p>
      </div>
    </div>
    <div class=" justify-content-md-center">
      <form [formGroup]="adminGarantiaForm" class="custom-form row" (ngSubmit)="onSubmit()">
        <div class="col-12 col-sm-4 mt-4">
          <div class="mb-3 required form-label" [ngClass]="{err: isValidForm('montoInicial')}">
            <label class="form-label">Nombre</label>
            <input placeholder="nombre" type="text" maxlength="40" class="form-control" formControlName="nombre"
              [ngClass]="{'is-invalid':isValidForm('nombre')}" required>
              <div class="invalid-feedback">
                Campo obligatorio
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-4 mt-4">
            <div class="mb-3 required form-label" [ngClass]="{'is-invalid': isValidForm('estado')}">
              <label class="form-label">Estado de la condición</label>
              <select class="form-control" formControlName="estado" [ngClass]="{'is-invalid': isValidForm('estado')}" required>
                <option value="">Selecione una opción</option>
                @for (item of listaEstados; track item) {
                  <option [value]="item">{{item}}</option>
                }
              </select>
              <div class="invalid-feedback">Campo obligatorio</div>
            </div>
          </div>
          <div class="col-12 col-sm-4 align-self-center container-btn">
            <button type="submit" [disabled]="!adminGarantiaForm.valid" id="btn-agregar" class="btn btn-primary hvr-shrink">Agregar cargos y/o garantías</button>
          </div>
        </form>
      </div>

      <div class="row  pr-3 pl-3">
        <div class="table-responsive">
          <table class="table table-striped table-borderless rounded">
            <thead class="table_head">
              <tr>
                <th scope="col" class="no-styles table-header" id="date-rango">
                  Nombre Condición
                </th>
                <th scope="col" class="no-styles table-header" id="solicitante">
                  Estado Condición
                </th>
                <th scope="col" class="no-styles table-header" id="doc">
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody>
              @for (condicion of listaNeoGarantiaIntermediarioDTO; track condicion; let i = $index) {
                <tr>
                  <th scope="row" id="id-condicion">{{ condicion.nombre | uppercase }}</th>
                  <td>{{ condicion.estado | uppercase }}</td>
                  <td>
                    <button id="btn-editar" type="button" class="hvr-shrink" data-bs-toggle="modal" data-bs-target="#editModal" (click)="editarFila(i)"><i class="fas fa-pencil-alt"></i></button>
                    <button id="btn-borrar" type="button" class="hvr-shrink" (click)="borrarFila(i)"> <i class="fas fa-trash-alt"></i> </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>

      <div class="row justify-content-md-center">
        <div class="col-12 col-sm-4 container-btn">
          <button class="btn btn-primary hvr-shrink" style="width: 180px;" (click)="goHome()">Volver</button>
        </div>
      </div>
    </div>


    <!-- Modal -->
    <div class="modal fade" id="editModal" tabindex="-1" aria-labelledby="editModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="editModalLabel">EDITAR CARGO Y/O GARANTÍA</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">

            </button>
          </div>
          <div class="modal-body-monto m-3">
            <form class="custom-form" [formGroup]="editarGarantiaForm">
              <div class="box-montos">
                <div class="mb-3 required form-label"[ngClass]="{err: isValidFormEditar( 'nombre')} ">
                  <label for="nombre" class="form-label">Nombre</label>
                  <input class="form-control box-number" maxlength="40" type="text " formControlName="nombre"
                    [ngClass]="{ 'is-invalid':isValidFormEditar( 'nombre')} " required>
                    <div class="invalid-feedback" style="color: #dc3545 !important;">
                      Campo obligatorio
                    </div>
                  </div>
                </div>
                <div class="box-montos">
                  <div class="mb-3 required form-label" [ngClass]="{'is-invalid': isValidFormEditar('estado')}">
                    <label for="estado" class="form-label">Estado de la condición</label>
                    <select class="form-control" formControlName="estado" [ngClass]="{'is-invalid': isValidFormEditar('estado')}" required>
                      <option value="">Selecione una opción</option>
                      @for (item of listaEstados; track item) {
                        <option [value]="item">{{item}}</option>
                      }
                    </select>
                    <div class="invalid-feedback" style="color: #dc3545 !important;">Campo obligatorio</div>
                  </div>
                </div>
                <div class="box-montos">
                  <div class="mb-3 required form-label" [ngClass]="{err: isValidFormEditar( 'justificacion')} ">
                    <p>Justificación</p>
                    <textarea class="form-control" maxlength="200" style="width: 100%;" rows="3 " type="text" formControlName="justificacion" [ngClass]="{ 'is-invalid':isValidFormEditar( 'justificacion')} " required></textarea>
                    <div class="invalid-feedback" style="color: #dc3545 !important;">
                      Campo obligatorio
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Cancelar</button>
              <button type="button" class="btn btn-primary" (click)="editarGarantia()">Modificar cargo y/o garantía</button>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal -->
      <div class="modal fade" id="deleteModal" tabindex="-1" aria-labelledby="deleteModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="deleteModalLabel">BORRAR CARGO Y/O GARANTÍA</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">

              </button>
            </div>
            <div class="modal-body-monto m-3">
              <div class="box-montos">
                <div class="mb-3 required text-start">
                  <p>Justificación</p>
                  <textarea maxlength="200" style="width: 100%;" rows="3" type="text" required name="justificacionDelete" [(ngModel)]="eliminarNeoGarantiaIntermediarioDTO.justificacion"></textarea>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Cancelar</button>
              <button type="button" class="btn btn-primary" (click)="borrarRango()">Borrar Cargo y/o garantía</button>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-body"></div>
    </div>
    <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
